/*
 * Free sample picker for Herbalight (Ella theme).
 * Keep THRESHOLD and HANDLES in sync with snippets/free-sample-picker.liquid
 * and the automatic discount "Free Sample on orders over Rs 3,000".
 */
(function () {
  if (window.__freeSamplePicker) return;
  window.__freeSamplePicker = true;

  var THRESHOLD = 300000; // paisa, Rs 3,000
  var HANDLES = ['hybrid-sunscreen-sample', 'glycolic-acid-sample'];
  var SAMPLE_TYPE = 'Sample';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;
  var checkoutVerified = false;

  function url(path) {
    return root.replace(/\/$/, '') + '/' + path;
  }

  function post(path, body) {
    return fetch(url(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw json;
        return json;
      });
    });
  }

  function getCart() {
    return fetch(url('cart.js'), { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function isSampleItem(item) {
    return item.product_type === SAMPLE_TYPE || HANDLES.indexOf(item.handle) > -1;
  }

  function isInDrawer(el) {
    return !!(el && el.closest && el.closest('#halo-cart-sidebar'));
  }

  // Re-render wherever the picker lives. Cart page reloads; drawer re-fetches its template.
  function refresh(el) {
    var wrap = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
    var onCartPage = document.body.classList.contains('template-cart');

    if (!isInDrawer(el) || !wrap) {
      window.location.reload();
      return Promise.resolve();
    }

    return fetch(url('cart?view=ajax_side_cart'), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        wrap.innerHTML = html;
        return getCart();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        document.querySelectorAll('free-shipping-component').forEach(function (n) { n.dispatchEvent(new Event('change')); });
        if (onCartPage) window.location.reload();
      });
  }

  function showError(box, message) {
    var err = box && box.querySelector('[data-fs-error]');
    if (!err) return;
    err.textContent = message || 'Sorry, we could not add the sample. Please try again.';
    err.hidden = false;
  }

  function keysOf(box) {
    return (box.getAttribute('data-fs-keys') || '').split(',').filter(Boolean);
  }

  // Customer taps a sample card: swap out any existing sample, add the chosen one.
  function onChoose(btn) {
    if (busy) return;
    if (btn.classList.contains('is-selected')) return;
    var box = btn.closest('[data-free-sample]');
    var variantId = Number(btn.getAttribute('data-fs-add'));
    if (!box || !variantId) return;

    busy = true;
    box.classList.add('is-loading');

    var updates = {};
    keysOf(box).forEach(function (k) { updates[k] = 0; });
    var clear = Object.keys(updates).length ? post('cart/update.js', { updates: updates }) : Promise.resolve();

    clear
      .then(function () {
        return post('cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { 'Free sample': 'Yes' } }]
        });
      })
      .then(function () { return refresh(box); })
      .catch(function (e) {
        showError(box, e && e.description);
      })
      .then(function () {
        busy = false;
        box.classList.remove('is-loading');
      });
  }

  // Remove samples when the order drops below the threshold, and keep it to 1 sample.
  function buildFixFromCart(cart) {
    var eligible = 0;
    var sampleLines = [];
    cart.items.forEach(function (item) {
      if (isSampleItem(item)) sampleLines.push(item);
      else eligible += item.original_line_price;
    });
    var unlocked = eligible >= THRESHOLD;
    var totalQty = sampleLines.reduce(function (s, i) { return s + i.quantity; }, 0);
    if (!sampleLines.length) return null;
    if (unlocked && sampleLines.length === 1 && totalQty === 1) return null;

    var updates = {};
    sampleLines.forEach(function (item, i) {
      updates[item.key] = unlocked && i === 0 ? 1 : 0;
    });
    return updates;
  }

  function fixCart() {
    return getCart().then(function (cart) {
      var updates = buildFixFromCart(cart);
      if (!updates) return false;
      return post('cart/update.js', { updates: updates }).then(function () { return true; });
    });
  }

  function scan() {
    if (busy) return;
    var box = document.querySelector('[data-free-sample][data-fs-fix="true"]');
    if (!box) return;
    busy = true;
    fixCart()
      .then(function (changed) {
        busy = false;
        if (changed) return refresh(box);
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fs-add]');
    if (btn) {
      e.preventDefault();
      onChoose(btn);
    }
  });

  // Safety net before checkout: make sure the cart only holds a valid free sample.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#cart-checkout, #cart-sidebar-checkout, .button-checkout, [name="checkout"]');
    if (!btn || checkoutVerified) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fixCart()
      .catch(function () { return false; })
      .then(function () {
        checkoutVerified = true;
        btn.click();
        setTimeout(function () { checkoutVerified = false; }, 3000);
      });
  }, true);

  // Put the picker in the right spot: under the item list in the drawer,
  // and above the order summary on the cart page.
  function place() {
    document.querySelectorAll('#halo-cart-sidebar [data-free-sample]').forEach(function (box) {
      var wrap = box.closest('.previewCart-wrapper') || document;
      var list = wrap.querySelector('.previewCartList');
      if (list && list.nextElementSibling !== box) list.insertAdjacentElement('afterend', box);
    });

    var mount = document.querySelector('[data-fs-page-mount]');
    if (mount) {
      var pageBox = mount.querySelector('[data-free-sample]');
      var summary = document.querySelector('[data-cart-total]');
      if (pageBox && summary) {
        summary.insertBefore(pageBox, summary.firstChild);
        mount.parentNode.removeChild(mount);
      }
    }
  }

  // ---------- Product page banner ----------
  function formatMoney(cents) {
    var out;
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.money_format) {
      out = Shopify.formatMoney(cents, window.money_format);
    } else {
      out = 'Rs.' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return String(out).replace(/[.,]00(?=\D*$)/, '');
  }

  var banner = null;
  var bannerState = '';

  function mountBanner() {
    if (!document.body.classList.contains('template-product')) return null;
    if (banner && document.body.contains(banner)) return banner;
    var details = document.querySelector('.productView-details');
    var form = details && details.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var anchor = form.closest('.productView-moreItem') || form;
    banner = document.createElement('div');
    banner.className = 'fs-banner';
    banner.setAttribute('data-fs-banner', '');
    anchor.insertAdjacentElement('afterend', banner);
    return banner;
  }

  function renderBanner(cart) {
    var el = mountBanner();
    if (!el) return;
    var eligible = 0;
    cart.items.forEach(function (item) { if (!isSampleItem(item)) eligible += item.original_line_price; });
    var html;
    if (eligible >= THRESHOLD) {
      html = '<span class="fs-banner__icon" aria-hidden="true">&#127873;</span>' +
        '<span class="fs-banner__text"><strong>You\'ve unlocked a free sample!</strong> Choose yours in the cart.</span>' +
        '<a class="fs-banner__link" href="' + url('cart') + '">Choose sample</a>';
    } else {
      var pct = Math.min(100, Math.round((eligible / THRESHOLD) * 100));
      var msg = eligible > 0
        ? 'You\'re <strong>' + formatMoney(THRESHOLD - eligible) + '</strong> away from a free sample.'
        : 'Spend <strong>' + formatMoney(THRESHOLD) + '</strong> and choose a <strong>free sample</strong> with your order.';
      html = '<span class="fs-banner__icon" aria-hidden="true">&#127873;</span>' +
        '<span class="fs-banner__text">' + msg +
        '<span class="fs-picker__bar"><span style="width:' + pct + '%"></span></span></span>';
    }
    if (html !== bannerState) {
      bannerState = html;
      el.innerHTML = html;
    }
  }

  var bannerTimer;
  function updateBanner() {
    if (!document.body.classList.contains('template-product')) return;
    clearTimeout(bannerTimer);
    bannerTimer = setTimeout(function () {
      getCart().then(renderBanner).catch(function () {});
    }, 300);
  }

  // Refresh the banner whenever the theme changes the cart (fetch or XHR).
  var CART_CALL = /\/cart\/(add|change|update|clear)/;
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var p = origFetch.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_CALL.test(u)) p.then(updateBanner, updateBanner);
      } catch (e) {}
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, u) {
    try {
      if (CART_CALL.test(String(u))) this.addEventListener('loadend', updateBanner);
    } catch (e) {}
    return origOpen.apply(this, arguments);
  };

  var scanTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(function () { place(); scan(); }, 150);
  });

  function start() {
    place();
    observer.observe(document.body, { childList: true, subtree: true });
    scan();
    updateBanner();
    window.addEventListener('pageshow', function (e) { if (e.persisted) updateBanner(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
